import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Languages, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("lx_token", data.token);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#0B111E] flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="w-full max-w-sm bg-white rounded-2xl p-8 shadow-2xl"
      >
        <Link to="/" className="flex items-center gap-2.5 mb-8">
          <span className="w-9 h-9 rounded-lg bg-[#0B111E] text-white flex items-center justify-center">
            <Languages className="w-5 h-5" strokeWidth={1.8} />
          </span>
          <span className="font-heading font-bold text-xl text-[#0B111E]">
            Translate<span className="text-[#C87A4B]">It</span>
          </span>
        </Link>
        <h1 className="font-heading text-2xl font-bold text-[#0B111E] mb-1">Team Access</h1>
        <p className="text-sm text-slate-500 mb-6">Sign in to manage quote enquiries.</p>
        <form onSubmit={submit} className="flex flex-col gap-4">
          <input
            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="admin-login-email" placeholder="Email"
            className="h-11 px-3.5 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-[#C87A4B]/40 focus:border-[#C87A4B]"
          />
          <input
            type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-login-password" placeholder="Password"
            className="h-11 px-3.5 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-[#C87A4B]/40 focus:border-[#C87A4B]"
          />
          <button
            type="submit" disabled={busy} data-testid="admin-login-submit"
            className="h-11 rounded-lg bg-[#C87A4B] hover:bg-[#B3673A] disabled:opacity-60 text-white font-semibold text-sm flex items-center justify-center gap-2 transition-colors"
          >
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} Sign In
          </button>
        </form>
      </motion.div>
    </div>
  );
}
